import { TMetaPrimitives } from '@cian/logger/shared';

import {
  EAnalyticsKey,
  EDealType,
  EOfferCategory,
  EOfferType,
} from '../../repositories/chats/entities/chat_hint/SaveChatHintsByOfferRequestSchema';
import {
  TSaveChatMessagesHintsByOfferResponse,
  fetchSaveChatMessagesHintsByOffer,
} from '../../repositories/chats/v1/save-chat-messages-hints-by-offer';
import { TOffer } from '../../types/offer';
import { TThunkAction } from '../../types/redux/thunk';

type TSaveChatMessageHintParams = {
  offer: TOffer;
  analyticsKey: EAnalyticsKey;
  messageText: string;
};

export const saveChatMessageHint =
  ({ offer, analyticsKey, messageText }: TSaveChatMessageHintParams): TThunkAction<Promise<void>> =>
  async (dispatch, getState, context) => {
    const { httpApi, logger } = context;

    const parameters = {
      analyticsKey,
      dealType: offer.dealType as EDealType,
      messageText,
      offerCategory: offer.category as EOfferCategory,
      offerType: offer.offerType as EOfferType,
    };

    try {
      const { response, statusCode }: TSaveChatMessagesHintsByOfferResponse = await fetchSaveChatMessagesHintsByOffer({
        httpApi,
        parameters,
        config: {
          requestConfig: {
            withCredentials: true,
          },
        },
      });

      if (statusCode !== 200) {
        logger.warning(response.message as string, {
          domain: 'src/shared/services/saveChatMessageHint.ts [saveChatMessageHint]',
          message: 'Не удалось сохранить вопрос-подсказку',
          errors: response.errors as unknown as TMetaPrimitives[],
        });
      }
    } catch (error) {
      logger.error(error, {
        domain: 'src/shared/services/saveChatMessageHint.ts [saveChatMessageHint]',
        message: 'Не удалось сохранить вопрос-подсказку',
      });
    }
  };
